import appColors from '@/theme/colors';

const tintColorLight = appColors.accent.primary;
const tintColorDark = appColors.accent.primary;

export default {
  light: {
    text: appColors.text.primary,
    background: appColors.background.app,
    tint: tintColorLight,
    tabIconDefault: appColors.text.muted,
    tabIconSelected: tintColorLight,
  },
  dark: {
    text: appColors.text.primary,
    background: appColors.background.app,
    tint: tintColorDark,
    tabIconDefault: appColors.text.muted,
    tabIconSelected: tintColorDark,
  },
};
